module.exports = __webpack_public_path__ + "static/media/main.eeb8bf1d.webm";